import { API_PHARMACY } from 'utils/constants'
import Api from './axiosInstance'

// To Upload catalogue in server
export const importPharmacyCatalogue = async (data: any) => {
  return Api.post({
    url: API_PHARMACY.IMPORT_CATALOGUE,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const importDeleteStoreAssociation = async (data: any) => {
  return Api.post({
    url: API_PHARMACY.DELETE_STORE_ASSOCIATION,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
